<template>
    <div class="container">
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                    <profile-intro-panel-dashboard @profilePanelChange="onProfilePanelChange"/>

                    <transition name="fade">
                        <profile-panel-dashboard v-if="profilePanelVisible"/>
                    </transition>

                    <work-experience-panel />
                    <studies-panel />
                    <tests-panel />

                    <documents-panel />
                    <applications-panel />
                    <invoices-panel />

                    <surveys-panel />

                </div>
                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                    <trajectory-info-panel />
                    <notes-panel />

                    <button @click="showDeleteTrajectoryModal" class="button red bold">
                        <i class="icons icon-trash"></i>
                        <span>{{$t('dashboard.delete_trajectory')}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    import ProfileIntroPanel from '@/components/panels/dashboard/ProfileIntroPanel';
    import ProfilePanel from '@/components/panels/dashboard/ProfilePanel';
    import TrajectoryInfoPanel from '@/components/panels/dashboard/TrajectoryInfoPanel';
    import NotesPanel from '@/components/panels/dashboard/NotesPanel';
    import DocumentsPanel from '@/components/panels/dashboard/DocumentsPanel';
    import WorkExperiencePanel from '@/components/panels/dashboard/WorkExperiencePanel';
    import StudiesPanel from '@/components/panels/dashboard/StudiesPanel';
    import TestsPanel from '@/components/panels/dashboard/TestsPanel';
    import ApplicationsPanel from '@/components/panels/dashboard/ApplicationsPanel';
    import InvoicesPanel from '@/components/panels/dashboard/InvoicesPanel';
    import SurveysPanel from '@/components/panels/dashboard/SurveysPanel';

    import { Client, Trajectory } from '@/models';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';

    @Component({
        components: {
            ProfileIntroPanel,
            ProfilePanel,
            TrajectoryInfoPanel,
            NotesPanel,
            DocumentsPanel,
            WorkExperiencePanel,
            StudiesPanel,
            TestsPanel,
            ApplicationsPanel,
            InvoicesPanel,
            SurveysPanel,
        }
    })
    export default class Dashboard extends Vue {
        name = 'dashboard';

        profilePanelVisible = false;

        created() {
            const id = this.$route.params.id;
            this.$store.dispatch(GET_TRAJECTORY, { id })
                .then(() => this.client.fill(this.$store.state.trajectory.trajectory.client))
                .catch(({ status, errors }) => {
                    if (status === 404) {
                        this.$notify.error(this.$t('notify.trajectory.not_found', { id }));
                        this.$router.replace({name: 'page_not_found'});
                    }
                });
        }

        get loading() {
            return this.$store.state.trajectory.loading;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        onProfilePanelChange(profilePanelVisible) {
            this.profilePanelVisible = profilePanelVisible;
        }

        showDeleteTrajectoryModal() {
            const content = {
                title: this.$t('modals.delete_trajectory.title'),
                message: this.$t('modals.delete_trajectory.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteTrajectory});
        }

        deleteTrajectory() {
            this.trajectory.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.trajectory.delete_success'));
                    this.$router.push({name: 'evaluation-students'});
                })
                .catch(err => this.$notify.error(this.$t('notify.trajectory.delete_error')));
        }

    }

    Vue.component('dashboard', Dashboard);
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue